<div class="modal-dialog" [class.text-center]="data.centerText" [attr.data-uiid]="data.promptUiid">
    <div class="modal-content">
        @if (data.title) {
            <div class="modal-header">
                <h5 class="modal-title">{{ data.title }}</h5>
            </div>
        }
        <div class="modal-body" [class.p-0]="data.hideBodyPadding">
            @if (data.message) {
                <p>{{ data.message }}</p>
            }
            @if (data.showLoader) {
                <div class="fancy-loader submodule"></div>
            }
            @if (data.fields && data.fields.length > 0) {
                <div class="fields">
                    <div class="cerrix-control-sm container-fluid">
                        <div class="row">
                            @for (field of data.fields; track field) {
                                <div
                                    class="form-group col-{{
                                        field.editorWidth ? field.editorWidth : '12'
                                    }}"
                                >
                                    @if (!field.hideInEdit) {
                                        <generic-field-editor
                                            [row]="data.fieldResult"
                                            [field]="field"
                                            [editEnabled]="!field.isReadonly"
                                        ></generic-field-editor>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            @if (data.customTemplate) {
                <div [attr.data-uiid]="data.customTemplateDataUiid" class="custom-template">
                    <ng-container
                        *ngTemplateOutlet="data.customTemplate; context: data.customTemplateContext"
                    ></ng-container>
                </div>
            }
        </div>
        @if (data.showButtonBar) {
            <div class="modal-footer">
                @if (data.extraButtons) {
                    <div class="left-area">
                        @for (btn of data.extraButtons; track btn) {
                            <button
                                [attr.data-uiid]="btn.uiid"
                                type="button"
                                [ngClass]="btn.class"
                                (click)="btn.action()"
                                [hidden]="!btn.show"
                            >
                                @if (btn.icon) {
                                    <cerrix-icon-viewer
                                        [icon]="btn.icon"
                                        [defaultColor]="btn.iconColor"
                                    ></cerrix-icon-viewer>
                                }
                                <span class="d-none d-lg-inline ms-2">{{ btn.text }}</span>
                            </button>
                        }
                    </div>
                }
                <div class="right-area">
                    @if (data.cancelButton.show) {
                        <button
                            type="button"
                            [ngClass]="data.cancelButton.class"
                            (click)="cancelClick()"
                        >
                            @if (data.cancelButton.icon) {
                                <cerrix-icon-viewer
                                    [icon]="data.cancelButton.icon"
                                    defaultColor="white"
                                ></cerrix-icon-viewer>
                            }
                            <span class="d-none d-lg-inline ms-2">{{
                                data.cancelButton.text
                            }}</span>
                        </button>
                    }
                    @if (data.confirmButton.show) {
                        <button
                            [attr.data-uiid]="data.confirmButton.uiid"
                            type="button"
                            [ngClass]="data.confirmButton.class"
                            (click)="confirmClick()"
                        >
                            @if (data.confirmButton.icon) {
                                <cerrix-icon-viewer
                                    [icon]="data.confirmButton.icon"
                                    defaultColor="white"
                                ></cerrix-icon-viewer>
                            }
                            <span class="d-none d-lg-inline ms-2">{{
                                data.confirmButton.text
                            }}</span>
                        </button>
                    }
                </div>
            </div>
        }
    </div>
</div>
<div [class]="ngSelectHolderCls"></div>
